import { useEffect, useState } from 'react';
import api from '../../api';

const useHttpGetGatewaysAmongDevices = deviceIds => {
    const [data, setData] = useState({ device_ids: [] });
    const [fetchedKey, setFetchedKey] = useState(null);
    const key = JSON.stringify(deviceIds);

    useEffect(() => {
        let active = true;

        const fetchGateways = async () => {
            try {
                const res = await api.get_gateways_among_devices(deviceIds);
                if (active) {
                    setData(res);
                }
            } catch (err) {
                console.error('Error loading gateways', err);
                if (active) {
                    setData({ device_ids: [] });
                }
            } finally {
                if (active) {
                    setFetchedKey(key);
                }
            }
        };

        fetchGateways();
        return () => {
            active = false;
        };
    }, [key]);

    // isReady is true only once the fetch for the *current* deviceIds has resolved.
    // When deviceIds changes (e.g. the device list finishes loading) this flips back
    // to "loading" in the same render, preventing a brief "no gateways found" flash.
    const isReady = fetchedKey === key;

    return { data, isReady };
};

export default useHttpGetGatewaysAmongDevices;
